import { SITE_LAYOUT } from 'config/siteLayout';

import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  /**
   * Single column below the app bar: grows in `_app`’s shell, holds optional full-width slot + content row.
   * Absorbs former `pageMain` styles so `_app` does not need an extra wrapper.
   */
  layoutContainer: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(6),
    },
  },
  /** `margin` option: top margin only on the outer column (24px mobile, 48px desktop). */
  layoutContainerMargin: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6),
    },
  },
  /** Grows below full-width slot; `alignItems: stretch` is set on the Stack (row cross-axis). */
  layout: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
  },
  /**
   * `gutter` option: horizontal inset on the inner content row (all breakpoints).
   * Uses padding (not margin) so `width: 100%` + `maxWidth` stay inside the column; horizontal
   * margins on a `width: 100%` flex child overflow the parent and read as full bleed.
   */
  layoutGutter: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    boxSizing: 'border-box',
  },
  layoutWidthFull: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    alignSelf: 'center',
    boxSizing: 'border-box',
  },
  layoutWidthWide: {
    width: '100%',
    maxWidth: SITE_LAYOUT.layoutContentWide,
    minWidth: 0,
    alignSelf: 'center',
    boxSizing: 'border-box',
  },
  layoutWidthMd: {
    width: '100%',
    maxWidth: SITE_LAYOUT.layoutContentMd,
    minWidth: 0,
    alignSelf: 'center',
    boxSizing: 'border-box',
  },
  layoutWidthSm: {
    width: '100%',
    maxWidth: SITE_LAYOUT.layoutContentSm,
    minWidth: 0,
    alignSelf: 'center',
    boxSizing: 'border-box',
  },
  /** Optional top/bottom ad rows: do not shrink inside the flex column. */
  adSlotSection: {
    flexShrink: 0,
    width: '100%',
  },
}));
